import React from "react"
import { withRouter } from "react-router-dom"
import {Heading, BackToHomeBtn, NotFoundContainer, SubHeading } from "./styles"
import { menuItemObj } from '../../components/PrivatePage'

const NotFound404 = ({history}) => {
    const navigateToHomeHandler = () => history.push(menuItemObj.home)

    return <NotFoundContainer>
        <Heading>404</Heading>
        <SubHeading>Sorry, Page Not Found</SubHeading>
        <BackToHomeBtn onClick={navigateToHomeHandler}>Back To Home</BackToHomeBtn>
    </NotFoundContainer>
}

export default withRouter(NotFound404)
